<!-- eslint-disable prettier/prettier -->
<template>
  <header>
    <div class="title_bar">
      <div class="title_logo" @click="goPage('home')"><img src="../assets/images/logo_top.png" alt="logo" /></div>
      <ul class="menu_ul">
        <li class="menu_li" @click="goPage('notice')">공지사항</li>
        <li class="menu_li" @click="goPage('announce')">공고관리</li>
        <li class="menu_li" @click="goPage('mypage')">마이페이지</li>
        <li class="menu_li" @click="goPage('resourceBoard')">자료실</li>
      </ul>
      <div class="title_menu_ul">
        <div class="title_menu">
          <li v-if="!store.isLogin" class="title_menu_li" @click="goPage('login')">로그인</li>
        </div>
        <div class="title_menu">
          <li v-if="!store.isLogin" class="title_menu_li" @click="goPage('signup')">회원가입</li>
        </div>
        <!-- <li v-if="store.isLogin" class="title_menu_li" @click="logout()">로그아웃</li> -->
        <li v-if="store.isLogin" class="title_menu_li" @click="logout()"><img src="@/assets/images/logout_icon.png" /></li>
        <!-- <div class="title_menu">
          <img src="@/assets/images/home_icon.png" width="30px" height="30px" @click="goPage('home')" style="cursor: pointer" />
        </div> -->

        <!-- <li class="title_menu_li" @click="goPage('home')">홈</li>  -->

        <!-- <router-link :to="{ name: 'home' }" class="title_menu_li">홈</router-link>
        <router-link :to="{ name: 'login' }" class="title_menu_li">로그인</router-link>
        <router-link class="title_menu_li">로그아웃</router-link> -->
      </div>
    </div>
  </header>

  <div class="contents">
    <div class="main_container">
      <router-view />
    </div>

    <footer>
      <div class="footer_menu_div">
        <ul class="footer_menu_ul">
          <li class="footer_menu_li" @click="goPage('termsOfService')">이용약관</li>
          <li class="footer_menu_li" @click="goPage('privacyPolicy')">개인정보취급방침</li>
        </ul>
      </div>
      <div class="footer_box">
        <div><img src="@/assets/images/logo_top.png" alt="" /></div>
        <div id="copyright">
          <div class="copyright_text">
            주식회사 파트너전자입찰시스템&nbsp; | &nbsp;사업자번호 : 844-86-02440&nbsp; | &nbsp;통신판매업 : 제2022-서울마포-2662호<br />
            주소 : 서울특별시 마포구 성암로 189, 1606호(상암동, 중소기업 DMC타워)<br />
            <span class="str">대표전화 : 02-376-9990</span>&nbsp; | &nbsp;<span class="str">팩스 : 02-376-9989</span>&nbsp; | &nbsp;이메일 : ptbid@naver.com
            <div>Copyright ⓒ 2022~ 주식회사 파트너전자입찰시스템 All rights reserved</div>
          </div>
          <a href="javascript:scrollTop();" class="btn_footer_top"></a>
        </div>
      </div>
    </footer>
  </div>
</template>
<script lang="ts" setup>
import loginAPI from "@/api/loginAPI";
import { userStore } from "@/store/userStore";
import { onMounted,  } from "vue";
import { useRouter, onBeforeRouteLeave } from "vue-router";

const router = useRouter();
const store = userStore();

onBeforeRouteLeave((to, from, next) => {
  console.log(to,from,"to,from");
  // Skip the check if already navigating to certificateApproval to prevent loops
  if (to.name === 'certificateApproval') {
    next();
    return;
  }
  
  if (store.isLogin && store.userInfo.가입상태 === '신청') {
    if(to.name === "announce" || to.name === "mypage" || to.name === "resourceBoard") {    
      next({ name: "certificateApproval" });
    } else {
      next();
    }
  } else {
    next();
  }
});
onMounted(() => {
  if (router.currentRoute.value.name == "main") {
    router.push({ name: "home" });
  } 
  if(store.userInfo.가입상태 == '신청') {
    router.push({ name: "certificateApproval" });
  }
});

const goPage = (page: string) => {
  if (page === "announce" || page === "mypage" || page === "resourceBoard") {
    if (store.isLogin == false) {
      alert("로그인 후 이용하실 수 있습니다.");
      router.push({ name: "login" });
      return;
    } else {
      if(store.userInfo.가입상태 === '신청') {
        alert("가입승인 후 이용하실 수 있습니다.");
        router.push({ name: "certificateApproval" });
        return;
      }
      window.scrollTo({ top: 0, behavior: "auto" });
      router.push({ name: page });
      return;
    }
  }
  window.scrollTo({ top: 0, behavior: "auto" });
  router.push({ name: page });
};

const logout = () => {
  if (window.confirm("로그아웃 하시겠습니까?")) {
    loginAPI.logout().then(() => {
      store.logout();
      router.push({ name: "home" });
    });
  }

  // router.push({ name: "home" });
};
</script>
<style>
#app {
  display: flex;
  flex-direction: column;
}
header {
  display: flex;
  justify-content: space-between;
  align-items: center;
  align-items: center;
  flex-direction: column;
  width: 100%;
  border-bottom: 1px solid #dbdbdb;
}

.title_bar {
  height: 120px;
  display: flex;
  justify-content: space-between;
  align-items: center;

  width: 80%;
}

.menu_bar {
  height: 54px;
  background-color: #337ab7;
  display: flex;
  justify-content: center;
  align-items: center;
  width: 100%;
}

.menu_ul {
  display: flex;
  justify-content: space-around;
  /* height: 54px; */
  gap: 100px;
  min-width: 565px;
}

.menu_li {
  color: #272727;
  font-family: "Noto Sans CJK KR-Bold";
  font-size: 18px;
  list-style: none;
  cursor: pointer;
}

.menu_li:hover {
  transition: 0.3s;
}

.title_menu_ul {
  display: flex;
  justify-content: center;
  align-items: center;
  min-width: 155px;
}

.title_menu {
  padding-left: 10px;
}

.title_menu_li {
  padding: 0 10px;
  font-size: 14px;
  font-weight: bold;
  cursor: pointer;
  color: #232a58;
  /* border-bottom: 1px solid #232A58; */
  text-decoration: underline;
  text-decoration-thickness: 0.5px;
  text-underline-offset: 5px;
}

.title_menu_li:last-child {
  border: 0;
}

.contents {
  display: flex;
  align-items: center;
  flex-direction: column;
  overflow-y: scroll;
}

.main_container {
  width: 1262px;
  display: flex;
}

footer {
  width: 100%;
  display: flex;
  flex-direction: column;
  align-items: center;
  background: #f6f7fb;
}

.footer_menu_div {
  height: 50px;
  display: flex;
  justify-content: center;
  align-items: center;
  width: 100%;
  padding: 15px 0;
  background: #f6f7fb;
  border-bottom: 1px solid #dbdbdb;
}

.footer_menu_ul {
  width: 1200px;
  display: flex;
}

.footer_menu_li {
  padding: 0px 10px;
  border-right: 1px solid #ddd;
  font-size: 13px;
  color: #242424;
  cursor: pointer;
}

.footer_menu_li:last-child {
  border-right: 0;
}

.footer_box {
  display: flex;
  align-items: center;
  width: 1200px;
  gap: 130px;
  padding: 25px 0px;
}

.copyright_text {
  font-size: 13px;
  color: #787878;
}

.title_logo {
  cursor: pointer;
  font-size: 15px;
  font-family: "Noto Sans CJK KR-Bold";
  display: flex;
  align-items: center;
  justify-content: center;
  gap: 10px;
}

/* .menu_line {
  width: 30px;
  border-bottom: 1px solid #232A58 ;
} */
</style>
